import { findElement } from 'base/tools';

let modal;
let backdrop;
const body = document.querySelector('body');

const evtOpts = {
	bubbles: true,
	cancelable: true
};
export const MODAL_OPEN_EVT = 'cj.modal.open';
export const MODAL_CLOSE_EVT = 'cj.modal.close';

const openEvent = new CustomEvent(MODAL_OPEN_EVT, evtOpts);
const closeEvent = new CustomEvent(MODAL_CLOSE_EVT, evtOpts);

const modalClickHandler = ({ target, ...event }) => {
	const content = modal.querySelector('.modal-content');
	const insideContent = content.contains(target);
	if (! insideContent) return closeModal();

	const dismissBtn = modal.querySelector('[data-dismiss="modal"]');
	if (! dismissBtn) return;
	const insideBtn = dismissBtn.contains(target);
	if (insideBtn) return closeModal();
};

const escapeListener = ({ keyCode, ...event }) => {
	if (keyCode !== 27) return;
	closeModal();
};

export const closeModal = () => {
	modal.dispatchEvent(closeEvent);
	body.classList.remove('modal-open');
	backdrop.parentElement.removeChild(backdrop);
	modal.style.display = 'none';
	modal.classList.remove('in');
	unlisten();
};

const listen = () => {
	modal.addEventListener('click', modalClickHandler, false);
	body.removeEventListener('click', modalOpenHandler, false);
	body.addEventListener('keyup', escapeListener, false);
};

const unlisten = () => {
	modal.removeEventListener('click', modalClickHandler, false);
	body.addEventListener('click', modalOpenHandler, false);
	body.removeEventListener('keyup', escapeListener, false);
	backdrop = null;
	modal = null;
};

export const openModal = modalTarget => {
	if (modal) closeModal();
	body.classList.add('modal-open');
	backdrop = document.createElement('DIV');
	body.appendChild(backdrop);
	backdrop.classList.add('modal-backdrop');
	backdrop.classList.add('fade');
	backdrop.classList.add('in');
	modal = modalTarget;

	modal.style.display = 'block';
	modal.classList.add('in');
	listen();
	modal.dispatchEvent(openEvent);
};

export const toggleModal = modalTarget => modal
	? closeModal()
	: openModal(modalTarget);

const modalOpenHandler = event => {
	const { target } = event;
	const trigger = findElement(target, 'modal');
	if (! trigger) return;
	const modalTarget = document.querySelector(trigger.dataset.target);
	if (! modalTarget) return;
	const isAnchor = trigger.tagName.toUpperCase() === 'A';
	if (isAnchor) event.preventDefault();
	openModal(modalTarget);
};

const UNSAFE_MODAL_EXPOSE = () => {
	window.cj.UNSAFE_MODAL_SHOW = openModal;
	window.cj.UNSAFE_MODAL_HIDE = closeModal;
	window.cj.UNSAFE_MODAL_TOGGLE = toggleModal;
};

const modals = () => {
	body.addEventListener('click', modalOpenHandler, false);
	// TODO: Kill with fire
	UNSAFE_MODAL_EXPOSE();
};

export default modals;
